module.exports = __webpack_public_path__ + "Observatory-52255c86f9f4bf8278c1a8d80dce1433.png";